import InvestorInvestManageContent from './investor-invest-manage-content';

export default InvestorInvestManageContent;
